import { HStack } from '@web/components/atoms/Layout'
import { Image } from '@web/components/atoms/Image'

type PaymentMarksProps = {
  hasPayPal?: boolean
}

const PaymentMark = ({ src, alt }: { src: string; alt: string }) => (
  <Image src={src} alt={alt} width="40px" height="24px" objectFit="contain" />
)

const PaymentMarks = ({ hasPayPal }: PaymentMarksProps) => {
  return (
    <HStack w="100%" justifyContent="center">
      <PaymentMark src="/assets/mastercard.svg" alt="Mastercard" />
      <PaymentMark src="/assets/visa.png" alt="Visa" />
      <PaymentMark src="/assets/amex.svg" alt="Amex" />
      <PaymentMark src="/assets/discover.png" alt="Discover" />
      <PaymentMark src="/assets/gpay.png" alt="Google Pay" />
      <PaymentMark src="/assets/apay.svg" alt="Apple Pay" />
      {hasPayPal && <PaymentMark src="/assets/paypal.svg" alt="PayPal" />}
    </HStack>
  )
}

export default PaymentMarks
